import React from 'react';
import { cn } from '../../utils/cn';

type StatusTone = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

export interface StatusBadgeProps {
  children: React.ReactNode;
  tone?: StatusTone;
  // Kept for existing callers; badges are text-only so icons are not drawn.
  icon?: React.ReactNode;
  className?: string;
}

const toneClasses: Record<StatusTone, string> = {
  success: 'border-transparent bg-action-50 text-action-800',
  warning: 'border-transparent bg-warning-50 text-warning-700',
  danger: 'border-transparent bg-danger-50 text-danger-700',
  neutral: 'border-transparent bg-ink-100 text-ink-700',
  info: 'border-transparent bg-academy-50 text-academy-800',
};


export function StatusBadge({ children, tone = 'neutral', className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded border px-2 py-0.5 text-xs font-medium',
        toneClasses[tone],
        className,
      )}
    >
      <span>{children}</span>
    </span>
  );
}
